import GroupChatContainer from "../../../../Components/Applications/Chat/GroupChat/GroupChatContainer";

const GroupChat = () => {
  return <GroupChatContainer />;
};

export default GroupChat;
